// This file is main file for the listing page application in browser
// It's the webpack entrypoint for the whole aaplication
import * as log from 'loglevel';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StoreContext } from 'redux-react-hook';

import { resolveByCountry } from '@codex/helpers';

import Configuration from '../../configuration';
import { createAppStore } from './reduck/index.browser';
import Locale from './translations/UILocale';
import Settings from './settings/UISettings';
import { loadComparisionFromSessionStorage } from './reduck/comparisonPersistence';
import ListingPageApp from './UIComponents/ListingPageApp/ListingPageApp';

// this hides the cookies confirmation popup and black overlay background
// after the loading of the page for the development using production proxy on localhost
// the cookies confirmation popup is injected to the application by 3rd part library in analytics
if (Configuration.get('environment') === 'dev' && window.location.hostname === 'localhost') {
  const css = '#onetrust-consent-sdk { display: none; }';
  const head = document.head;
  const style = document.createElement('style');
  head.appendChild(style);
  style.appendChild(document.createTextNode(css));
}

const isErrorPageDuringServerRendering = !!window.ERROR_CODE;
const isSearchListingPage =
  window.location.href.includes(`${resolveByCountry('/gbuk', '/ieen')}/search-keywords/`);

// setting comparison data from session storage for compare panel
const comparisonFromSessionStorage = loadComparisionFromSessionStorage();
if (comparisonFromSessionStorage) {
  window.INIT_STATE.listingPage.comparison = comparisonFromSessionStorage;
}

// init redux store in browser using data from server
const appStore = createAppStore({ ...window.INIT_STATE });
// make redux store public (for external scripts)
window.appState = appStore;
delete window.INIT_STATE;

// setting Country
global.COUNTRY = Configuration.get('app_theme') === 'currysie' ? 'IE' : 'UK';

// set log levels on client
log.setLevel(log.levels.TRACE);
log.setLevel(log.levels[Configuration.get('logLevels.client')]);

// init listing page specific translations
// these translations are stored in redux store
Locale.initTranslations(appStore.getState().listingPage.staticData.translations);

// init listing page settings from redux store
// these settings are stored in redux store
Settings.initSettings(appStore.getState().listingPage.staticData.settings);

let render;
if (isErrorPageDuringServerRendering) {
  // when there is an error on server, we render error page in browser
  render = () => {
    ReactDOM.render(
      <StoreContext.Provider value={appStore}>
        <Provider store={appStore}>
          <ListingPageApp wasErrorOnServer errorCode={window.ERROR_CODE} />
        </Provider>
      </StoreContext.Provider>,
      document.getElementById('app')
    );
  };
} else if (isSearchListingPage) {
  // if it is search listing page, we render search page
  render = () => {
    ReactDOM.render(
      <StoreContext.Provider value={appStore}>
        <Provider store={appStore}>
          <ListingPageApp />
        </Provider>
      </StoreContext.Provider>,
      document.getElementById('app')
    );
  };
} else {
  // if it is segment listing page, we render segment listing page
  // Because segment listing page react components are rendered on the server because of SEO,
  // we use ReactDOM.hydrate function just to hydrate these components and not to re-render them
  render = () => {
    ReactDOM.hydrate(
      <StoreContext.Provider value={appStore}>
        <Provider store={appStore}>
          <ListingPageApp />
        </Provider>
      </StoreContext.Provider>,
      document.getElementById('app')
    );
  };
}

render();

// hot reload which only runs during development
if (module.hot) {
  module.hot.accept('./UIComponents/ListingPageApp/ListingPageApp', () => {
    render();
  });
}
